import production from './production-env';
import qa from './qa-env';
import sandbox from './sandbox-env';

let enviroment: any;

switch (process.env.REACT_APP_ENVIROMENT) {
  case 'qa':
    enviroment = qa;
    break;
  case 'production':
    enviroment = production;
    break;
  case 'sandbox':
    enviroment = sandbox;
    break;
  default:
    enviroment = qa;
    break;
}

export default enviroment;
